import { NgModule } from '@angular/core';
import { PopErrorOutletDirective } from './pop-error-outlet.directive';
import { SatPopoverAnchorDirective, SatPopoverComponent } from '@ncstate/sat-popover';


@NgModule({
  declarations: [ PopErrorOutletDirective ],
  imports: [ SatPopoverAnchorDirective, SatPopoverComponent ],
  exports: [ PopErrorOutletDirective ]
})
export class ZefPopErrorModule {

}
